import { useEffect, useState } from 'react';
import CustomTable from '../table';
import './index.scss';
import { Typography } from 'antd';
import { PaymentsAdmin } from '@/types';

const { Text } = Typography;

interface Props {
  payments: PaymentsAdmin[];
  columns: any[];
  total: number;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  downloadData?: (record: any) => void;
  scroll?: { x?: string | number | true; y?: string | number };
  paginationPosition?: 'top' | 'bottom';
  customFilters?: React.ReactNode;
}

export default function PaymentsTable({
  payments,
  columns,
  total,
  page,
  setPage,
  limit,
  setLimit,
  downloadData,
  scroll,
  paginationPosition,
  customFilters,
}: Props) {
  const [filteredData, setFilteredData] = useState<PaymentsAdmin[]>([]);

  useEffect(() => {
    const formattedData = payments
      ?.filter((payment) => payment?.consultant?.id && payment?.franchise?.id)
      .map((payment) => ({
        ...payment,
        key: payment.id,
      }));

    setFilteredData(formattedData || []);
  }, [payments]);

  return (
    <>
      <div className="tables-info">
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          {total} Total Payments
        </Text>
        <span className="tables-divider" />
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          Updated 20 min ago
        </Text>
      </div>
      <CustomTable
        data={filteredData}
        columns={columns}
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        isDatePicker={!customFilters}
        label="Payments"
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        downloadData={downloadData}
        scroll={scroll}
        paginationPosition={paginationPosition}
        customFilters={customFilters}
      />
    </>
  );
}
